<div class="card market-card">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5>{{ 'Market Graph' | translate }}</h5>
      <ul class="nav nav-tabs custom-tab" id="tabdesign" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="hour-tab" data-bs-toggle="tab" data-bs-target="#hour" type="button" role="tab" aria-selected="false">{{ '1H' | translate }}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="day-tab" data-bs-toggle="tab" data-bs-target="#day" type="button" role="tab" aria-selected="false">{{ '1D' | translate }}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="week-tab" data-bs-toggle="tab" data-bs-target="#week" type="button" role="tab" aria-selected="true">{{ '1W' | translate }}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="month-tab" data-bs-toggle="tab" data-bs-target="#month" type="button" role="tab" aria-selected="false">{{ '1M' | translate }}</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="year-tab" data-bs-toggle="tab" data-bs-target="#year" type="button" role="tab" aria-selected="false">{{ '1Y' | translate }}</button>
        </li>
      </ul>
    </div>
  </div>
  <div class="card-body pt-0">
    <div class="row m-0 overall-card">
      <div class="col-xxl-8 col-xl-7 col-md-8 col-sm-7 p-0 box-col-7 col-ed-7">
        <div class="market-chart-container">
          <div id="market-chart">
            <apx-chart [series]="marketChart.series" [chart]="marketChart.chart" [stroke]="marketChart.stroke" [dataLabels]="marketChart.dataLabels" [colors]="marketChart.colors" [grid]="marketChart.grid" [plotOptions]="marketChart.plotOptions" [fill]="marketChart.fill" [labels]="marketChart.labels" [markers]="marketChart.markers" [yaxis]="marketChart.yaxis" [xaxis]="marketChart.xaxis" [tooltip]="marketChart.tooltip" [legend]="marketChart.legend"></apx-chart>
          </div>
        </div>
      </div>
      <div class="col-xxl-4 col-xl-5 col-md-4 col-sm-5 p-0 box-col-5 col-ed-5">
        <div class="row g-sm-3 g-2">
          <div class="col-md-12">
            <div class="light-card balance-card align-items-center">
              <h6 class="f-w-400 f-14 mb-0">{{ 'Coinmarketcap' | translate }}</h6>
              <div class="ms-auto text-end"><span class="badge badge-light-success rounded-pill">{{ '+11.67%' | translate }}</span></div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="light-card balance-card align-items-center">
              <h6 class="f-w-400 f-14 mb-0">{{ 'Binance' | translate }}</h6>
              <div class="ms-auto text-end"><span class="badge badge-light-success rounded-pill">{{ '+10.67%' | translate }}</span></div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="light-card balance-card align-items-center">
              <h6 class="f-w-400 f-14 mb-0">{{ 'Coinbase' | translate }}</h6>
              <div class="ms-auto text-end"><span class="badge badge-light-secondary rounded-pill">{{ '-11.67%' | translate }}</span></div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="light-card balance-card align-items-center">
              <h6 class="f-w-400 f-14 mb-0">{{ 'Yobit' | translate }}</h6>
              <div class="ms-auto text-end"><span class="badge badge-light-success rounded-pill">{{ '+13.67%' | translate }}</span></div>
            </div>
          </div>
          <div class="col-md-12">
            <button class="btn btn-outline-dark w-100" type="button">{{ 'See All Balance' | translate }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
